import { BookingPageModel } from '@/typings/models/BookingPage';


export function getBookingPageLink(bookingPage: BookingPageModel, defaultLeadSourceConfiguration){
  if (!bookingPage) return null
  if (bookingPage?.booking_url) return bookingPage.booking_url
  if (!bookingPage.lead_source && defaultLeadSourceConfiguration && defaultLeadSourceConfiguration.base_url){
    return `${defaultLeadSourceConfiguration.base_url}?dynamic=book&content=booking_link_id:${bookingPage.id}`
  }
}

/**
 * The booking pages that belong to one lead source.
 *
 * A page either books into a lead source of its own or into none, and a page
 * with none resolves against the partner's **default** lead source — the same
 * rule {@see getBookingPageLink} builds its URL by. So the default scope owns
 * the unassigned pages, and every other journey shows only what points at it.
 *
 * `null` (nothing selected yet) leaves the list untouched.
 */
export function scopeBookingPages(
  pages: BookingPageModel[],
  journeyHashId: string | null,
  defaultHashId: string | null,
): BookingPageModel[] {
  if (!journeyHashId) return pages;

  return pages.filter((page) => {
    const source = page.lead_source?.id;
    return source ? source === journeyHashId : journeyHashId === defaultHashId;
  });
}
